export default __webpack_public_path__ + "29c0f8c6acb0c4282c651b091f9a2936.svg";